import { useTranslation } from 'react-i18next';
import { SkeletonLoader } from 'component-library';
import {
  DropdownHeaderWrapper,
  DropdownLabelStyled,
} from 'component-library/components/Input/Dropdown/components/DropdownHeader/styles';
import { LocationPickerProvider } from './hooks/useLocationPicker/LocationPickerProvider';
import { type LocationPickerProps } from './types';
import { LocationPickerDropdown } from './dropdown/LocationPickerDropdown';

export type { LocationGroup, LocationPickerProps } from './types';

export const LocationPicker = (props: LocationPickerProps) => {
  const showInactiveToggle = !!props.showInactiveToggle && !!props.multiSelect;

  return (
    <LocationPickerProvider
      locations={props.locations}
      showInactiveToggle={showInactiveToggle}
      hideInactiveLocations={props.hideInactiveLocations}
      onInactiveToggle={props.onInactiveToggle}
    >
      <LocationPickerDropdown {...props} />
    </LocationPickerProvider>
  );
};

export const LocationPickerSkeleton = () => {
  const { t } = useTranslation();

  return (
    <DropdownHeaderWrapper>
      <DropdownLabelStyled>{t('filter.businessPartners')}</DropdownLabelStyled>
      <SkeletonLoader shape="rounded" height="48px" width="100%" />
    </DropdownHeaderWrapper>
  );
};
